export const routes = {
  root: "/",
  admin: "/admin",
  adminPlayerProfile: "/admin/player/:id",
  adminClubProfile: "/admin/club/:id",
  getAdminPlayerProfilePath: (id: string) => `/admin/player/${id}`,
  getAdminClubProfilePath: (id: string) => `/admin/club/${id}`,

  profile: "/profile",
  players: "/players",
  clubs: "/clubs",

  club: "/club/:id",
  player: "/player/:id",
  getClubPath: (id: string) => `/club/${id}`,
  getPlayerPath: (id: string) => `/player/${id}`,

  onboarding: "/onboarding",

  favorites: "/favorites",
  tournaments: "/tournaments",
  tournament: "/tournament/:id",
  getTournamentPath: (id: string) => `/tournament/${id}`,

  messages: "/messages",

  plans: "/plans",

  signupPlayer: "/auth/signup-player",
  signupClub: "/auth/signup-club",
  signin: "/auth/signin",
  oauthCallback: "/auth/oauth-callback",
  oauthSignIn: "/auth/oauth-signin",
  signup: "/auth",
} as const;

export type Routes = typeof routes;
